import PANE from '../../../../../APP/page/pane/PANE.js';
import { text } from '../../../../../DOM/text/TEXT.js';
import { heading } from '../../../../../DOM/heading/HEADING.js';
import STRING from '../../../../../../STRING.js';
export default class PANE_Blog_Articles extends PANE {
    constructor(node, model) {
        let endpoint = 'core/messagebus/version';
        console.log('Initial Endpoint', endpoint);
        super(node, model);
        this.addClass('full-frame');
        this.addHeading(heading(1, 'Blog > Article One'));
        this.addP(text(new STRING().lipsum(2)));
    }
    translate() {
        console.log(`Translation not implemented for PANE::${this.toString()}`);
    }
}
